import React, { useContext } from "react";
import { SortableTable, Badge } from "@fixel/fixel-components";

import { ReactComponent as ExternalLink } from "./img/ExternalLink.svg";
import { StyledAudiencesContainer, StyledAudiencesTitle, StyledTableContainer } from "./audiences.style";
import IntegrateFBMsg from "./IntegrateFBMsg";
import StateContext from "../../../context/StateContext";
import { ReactComponent as ArrowSort } from "../../../img/upDown.svg";

const getKeyLabel = (label) => (
	<>
		{label}
		<ArrowSort />
	</>
);
const keys = [
	{ key: "audience", label: getKeyLabel("Audience"), sortable: true },
	{ key: "size", label: getKeyLabel("Size"), sortable: true },
	{ key: "status", label: getKeyLabel("Status"), sortable: true }
];

const Audiences = ({ code }) => {
	const { segMap, audMap } = useContext(StateContext);
	const createSegmentList = (list = []) => {
		return list.map((row) => {
			let newRow = {};
			newRow.audience = row.name;
			newRow.size = row.size ? row.size : 0;
			const status = row.status.toLowerCase();
			if (status === "active") {
				newRow.status = <Badge color="green" label="Ready" value="ready" />;
			} else if (status === "calculating" || status === "new") {
				newRow.status = <Badge color="orange" label="Populating" value="populating" />;
			} else {
				newRow.status = <Badge color="grey" label={status} value={status} />;
			}
			return newRow;
		});
	};

	const renderAudienceTable = () => {
		// act_1086141482084 --> ["act", "1086141482084"] --> 1086141482084
		const FBAccountId = audMap[code][0]?.account.split("_")[1];
		return (
			<StyledTableContainer>
				<StyledAudiencesTitle>
					<h3>Facebook Audiences</h3>
					<a target="_blank" rel="noreferrer" href={`https://business.facebook.com/adsmanager/audiences?act=${FBAccountId}`}>
						<ExternalLink />
					</a>
				</StyledAudiencesTitle>
				<SortableTable data={createSegmentList(audMap[code])} keys={keys} defaultSortKey="status" />
			</StyledTableContainer>
		);
	};

	const renderAudienceContent = () => {
		if (audMap && audMap[code] && audMap[code]?.length && segMap && segMap[code]?.install_data && segMap[code]?.install_data?.options?.fb && segMap[code]?.install_data?.options?.capi) {
			return renderAudienceTable();
		} else {
			return <IntegrateFBMsg code={code} />;
		}
	};

	return <StyledAudiencesContainer>{renderAudienceContent()}</StyledAudiencesContainer>;
};
export default Audiences;
